<template>
  <div class="main">
        <!-- ===== Mobile Header ===== -->
    <media-header-index
      class="mobile-only"
      :titles="titles"
      @navigate="toPage"
    />

    <!-- ================= PC HEADER ================= -->
    <header class="main-header pc-only">
      <el-row :gutter="10" class="header-row">
        <!-- Logo -->
        <el-col :lg="12" :sm="8" class="logo-col">
          <img
            src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/index_logo.png"
            alt="Logo"
            class="logo"
          />
        </el-col>

        <!-- Navbar -->
        <el-col :lg="12" :sm="16" class="navbar">
          <div
            v-for="item in titles"
            :key="item.key"
            class="title"
            @click="toPage(item.key)"
          >
            {{ item.title }}
          </div>
        </el-col>
      </el-row>
    </header>


    <!-- ================= HERO ================= -->
    <section class="hero pc-only">
      <div class="main-bg">
        <img
          src="https://bsd-files.oss-cn-hangzhou.aliyuncs.com/BaoJin/index/index_nav.png"
          alt=""
        />
      </div>
    </section>

    <!-- Mobile Hero -->
    <section class="hero mobile-only">
      <div class="mobile-hero-bg"></div>
    </section>

    <!-- ================= NEWS (PC + Mobile 共用) ================= -->
    <section class="news-section">
      <h2 class="news-title">News and Highlights</h2>

      <div class="divider"></div>

      <section class="news-columns">
        <div class="news-column">
          <div class="news-image">
            <img :src="require('@/assets/news/sino.png')" alt="News 1" />
          </div>
          <div class="news-date">Nov 06 - 08,  2024</div>
          <p class="news-text">
            We organized Sino-German workshop on “Frontiers of Basic and Medical Research in Peptide Regulation” in Shenzhen and it was a fantastic event!
          </p>
        </div>

        <div class="news-column">
          <div class="news-image">
            <img :src="require('@/assets/news/valery.png')" alt="News 2" />
          </div>
          <div class="news-date">Nov 05,  2024</div>
          <p class="news-text">
            China-EU Joint Laboratory for Translational research of Neuromodulation is founded in SIAT.<br />
            The joint lab is codirected by Profs. Jin BAO and Valery Grinevich.
          </p>
        </div>

        <div class="news-column">
          <div class="news-image">
            <img :src="require('@/assets/news/group_project.png')" alt="News 3" />
          </div>
          <div class="news-date">Nov 01,  2024</div>
          <p class="news-text">
            BAOLAB is taking the leading role in the prestigious grant from CAS.
          </p>
        </div>
      </section>

      <div class="divider"></div>
      <section class="news-columns">

      <!-- News 1 -->
      <div class="news-column">
        <div class="news-image">
          <img src="https://bsd-files.oss-cn-hangzhou.aliyuncs.com/BaoJin/index/fens.png" />
        </div>
        <div class="news-date">June 25 - 29, 2024</div>
        <p class="news-text">
          Dejiao Xu, on behalf of the team members, presented the results on lithium study in the 2024 Federation of European Neuroscience Societies (FENS) Forum held in Vienna, Austria
        </p>
      </div>

      <!-- News 2 -->
      <div class="news-column">
        <div class="news-images">           
          <div class="news-img-box news-img-box--big">            
            <img src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/labs/cell.png" />           
          </div>         
            <div class="news-img-box">            
              <img src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/labs/oxy.png" />          
            </div>   
          </div>
        <div class="news-date">August 2022</div>
        <p class="news-text">
            “Melanopsin retinal ganglion cells mediate light-promoted brain development”
            is online now!
        </p>
      </div>

      <!-- News 3 -->
      <div class="news-column">
        <div class="news-image">
          <img src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/labs/team.jpg" />
        </div>
        <div class="news-date">July 2022</div>
        <p class="news-text">
          Lab excursion in NanAO island
        </p>
      </div>

    </section>

    </section>

    <!-- ================= PC FOOTER ================= -->
    <el-row
      class="main-footer pc-only"
      :gutter="10"
      :style="{
        backgroundImage: `url(${require('@/assets/news/footer.png')})`
      }"
    >
      <el-col :span="24" style="margin-bottom: 5px;">
        Principal Investigator | Jin BAO
      </el-col>
      <el-col :span="24">
        Shenzhen Institute of Advanced Technology, Chinese Academy of Science
      </el-col>
    </el-row>

  </div>
</template>

<script>
import mediaHeaderIndex from "./media/mediaHeaderIndex";

export default {
  name: "Index",
  components: {
    mediaHeaderIndex,
  },
  data() {
    return {
      titles: [
        { title: "Research", key: "Research" },
        { title: "People", key: "People" },
        { title: "Science And Art", key: "Science" },
        { title: "Join us", key: "Joinus" },
        { title: "Contact us", key: "Contactus" },
      ],
    };
  },
  methods: {
    toPage(key) {
      this.$router.push(key);
    },
  },
};
</script>


<style scoped>
/* ========== Base ========== */
.main {
  position: relative;
  width: 100%;
  min-height: 100vh;
}

/* ========== Visibility Helpers ========== */
.pc-only {
  display: block;
}
.mobile-only {
  display: none;
}

/* ========== Header (PC) ========== */

.main-header { 
  position: absolute; 
  top: 2vh; 
  left: 0; 
  width: 100%; 
  z-index: 10; } 

.header-row { 
  display: flex; 
  align-items: center; 
  padding-left: calc(100vw * 80 / 1920); 
  padding-right: calc(100vw * 80 / 1920); }

.header-row {
  display: flex;
  align-items: center;
  padding-left: calc(100vw * 80 / 1920);
  padding-right: calc(100vw * 80 / 1920);
}

.logo-col {
  display: flex;
  align-items: center;
}

.logo {
  width: calc(100vw * 200 / 1920);
  height: calc(100vw * 95 / 1920);
  object-fit: contain;
}

.navbar {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: nowrap;
  cursor: pointer;
}

.title {
  flex: 1 !important;
  font-family: 'mon';
  font-size: clamp(22px, 1.5vw, 70px);
  color: aliceblue;
  text-rendering: optimizeLegibility;

  letter-spacing: clamp(-1px, -0.05vw, 0px);

  display: flex;
  justify-content: center;
  padding-top: calc(100vw * 10 / 1920);
  white-space: nowrap;
}


.title + .title {
  margin-left: clamp(20px, 1vw, 30px);
}

.title:hover {
  color: #4063f9;
}

/* ========== Hero ========== */

.hero {
  position: relative;
  width: 100%;
}


/* PC Hero 背景 */
.hero .main-bg {
  inset: 0;
  background: url("https://bsd-files.oss-cn-hangzhou.aliyuncs.com/BaoJin/index/index_nav.png")
    no-repeat center / cover;
}


/* ===== PC Hero（恢复原始比例，不压缩） ===== */

.hero.pc-only {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.hero.pc-only .main-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
}

.hero.pc-only .main-bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;   
  object-position: center;
  display: block;
}

/* ========== News (Shared) ========== */
.news-section {
  background: #fff;
  max-width: min(1800px, 85vw);
  margin: 40px auto;
  padding: 40px 80px;
  border-radius: 12px;

  position: relative;
  z-index: 1;
}

.news-title {
  font-family: "dela";
  font-size: clamp(28px, 3.5vw, 70px);  
  font-weight: 500;  
  letter-spacing: 0.5px;
  color: #4063f9;
  text-align: center;
  margin-bottom: 40px;
}

.divider {
  width: 100%;
  height: 1px;
  margin: 32px auto;
  background-color: #565656; 
}

.divider img {
  width: auto;     
  max-width: 100%;
  height: auto;
}

.news-date {
  font-size: clamp(22px, 0.8vw, 60px);
  font-family: 'mon';
  color: #999;
  letter-spacing: 0.02em;
  margin-top: 12px;
  margin-bottom: 6px;
  line-height: 1.2;
}

.news-text {
  font-size: clamp(22px, 1.3vw, 60px);
  line-height: 1.6;
}

.news-image {
  margin: 15px 0;
}

.news-image img {
  width: 100%;
  border-radius: 8px;
}

.news-images {
  display: flex;
  flex-direction: column;     /* 关键：上下排布 */
  gap: 20px;
  width: 100%;
}

/* 通用图片容器 */
.news-img-box {
  width: 100%;                /* 宽边严格对齐 */
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}



/* 图片通用规则 */
.news-img-box img {
  width: 100%;
  max-width: 100%;
  object-fit: contain;
}

.single-photo-small .news-image {
  display: flex;
}

.single-photo-small .photo-scale {
  width: 60%;      
}

.single-photo-small .photo-scale img {
  width: 100%;      
  height: auto;
  object-fit: contain;
}


/* 三栏容器 */
.news-columns {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
}

/* 单栏内容 */
.news-column {
  background-color: #f1f1f1;
  border-radius: 16px;
  padding: 20px 20px 28px;

  display: flex;
  flex-direction: column;
}

/* 图片：保持原比例，不裁剪 */
.news-image {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;

  display: flex;
  align-items: center;
}

.news-image img {
  max-width: 100%;
  height: auto;
  display: block;
}
/* ========== Footer (PC) ========== */
.main-footer {
  width: 100%;
  padding: 40px 0;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  color: #ffffff;
}


.main-footer a {
  font-size: clamp(28px, 1.2vw, 60px) !important;
}

.el-footer {
  text-align: center;
}

.main-footer > .el-col {
  text-align: center;
}

@media screen and (min-width: 2500px) {
  .news-section {
    max-width: clamp(2300px, 90vw, 4800px);
  }
}

@media screen and (min-width: 1200px) {
  .main {
    overflow-x: visible;
  }

@media (max-width: 2559px) {
  .hero.pc-only .main-bg {
    background-size: auto 100%;
  }
}

@media (min-width: 2560px) and (max-width: 3439px) {
  .hero.pc-only .main-bg {
    background-size: auto 100%;
  }
}

@media (min-width: 3840px) {
  .hero.pc-only .main-bg {
    background-size: 1800px auto; 
    background-position: center top;
  }
}

}
/* ========== Mobile ========== */
@media screen and (max-width: 768px) {
  .main-footer {
    display: none !important;
  }
  .media-768-header {
    display: block;
  }
  .main-text {
    padding-top: 60px;
  }
}

@media (max-width: 768px) {
  .pc-only {
    display: none !important;
  }
  .mobile-only {
    display: block;
  }

  .main {
    padding-top: 56px;
    background: #fff;
  }

  .mobile-hero {
    height: 40vh;
  }

  .news-section {
    margin: 0;
    padding: 20px;
    border-radius: 0;
  }

  .news-title {
    font-size: 18px;
  }

  .news-date {
    font-size: 10px;
  }


  .news-text {
    font-size: 12px;
    font-family: 微软雅黑;
  }

  .divider img {
    width: 100%;
    margin: 24px 20px;
    max-width: none;
  }

  .news-images {
    flex-direction: column;
  }

  .news-columns {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .news-column p {
    font-size: 12px;
  }

  .hero.mobile-only {
    width: 100%;
    height: auto;
    aspect-ratio: 16 / 9;
    overflow: visible;
  }

  .hero.mobile-only .mobile-hero-bg {
    width: 100%;
    height: 100%; 
    background: 
      url("https://bsd-files.oss-cn-hangzhou.aliyuncs.com/BaoJin/index/index_nav.png")
      no-repeat center / contain;
    background-color: #fff;
  }

}
</style>


// WEBPACK FOOTER //
// src/components/Index.vue